import React, { Component, useEffect, memo } from 'react';
import styled from 'styled-components';
import arrowLeft from '../../assets/images/arrow_left.png';
import arrowRight from '../../assets/images/arrow_right.png';
import { ImageLazyLoad } from '../ImageLazyLoad';
import ScrollMagic from 'scrollmagic';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

const Image = styled(ImageLazyLoad)`
  width: 64px;
  height: auto;
  overflow: hidden;
  object-fit: contain;
  object-position: center;
`;

const Caption = styled.p`
  text-align: left;
  margin: 0;
  height: max-content;
  width: max-content;
  color: #1d1d1d;
  font-family: AvenirMedium;
  font-size: 26px;
  order: 1;
  @media (max-width: 992px) {
    order: 0;
  }
  @media (max-width: 768px) {
    font-size: 20px;
    letter-spacing: -0.07px;
    line-height: 27px;
  }

  /* @media (min-width: 768px) {
    align-self: center;
  } */
`;

const ReviewText = styled.blockquote`
  color: #121212;
  font-family: 'Roboto Slab';
  font-size: 24px;
  font-weight: 300;
  line-height: 1.6;
  text-align: justify !important;
  @media (max-width: 576px) {
    font-size: 20px;
    line-height: 36px;
    font-style: normal;
  }
`;

const TestimonalSliderHeading = styled.p`
  color: #1d1d1d;
  font-family: AvenirMedium;
  font-size: 48px;
  font-weight: 900;
  letter-spacing: -0.15px;
  line-height: 60px;

  @media (min-witdh: 577px) and (max-width: 992px) {
    font-size: 36px;
    font-weight: 900;
    line-height: 48px;
  }

  @media (max-width: 576px) {
    font-size: 32px;
    font-weight: 900;
    letter-spacing: -0.09px;
    line-height: 36px;
  }
`;

const TestimonialBox = styled.div`
  width: 100%;
  float: left;
  background-color: #f3f3f3;
  border-radius: 30px;
  padding: 40px 30px;
  margin-right: 5%;
`;

const SlideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: between;
  height: 100%;
`;

const TestimonialSlider = memo(({ items }) => {
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '#testimonials-wrapper',
        pin: true,
        start: 'center center',
        end: '+=300%',
        scrub: 1,
      },
    });

    tl.to('#testimonials', { x: '-66.6%' });
    // tl.to('#testimonials', { x: '0%' }, '+=0');
    // tl.to('#testimonials', { x: '-33.3%' }, '+=1');
    // tl.to('#testimonials', { x: '-66.6%' }, '+=2');
  }, []);

  return (
    <>
      <div id='testimonials-wrapper' style={{ width: '100%', height: '100%', perspective: 1000 }}>
        <TestimonalSliderHeading>People are talking about us</TestimonalSliderHeading>
        <div id='testimonials' style={{ width: '300%', display: 'inline-flex' }}>
          {items.map((item, index) => (
            <TestimonialBox key={index}>
              <SlideWrapper>
                <ReviewText>{item.review}</ReviewText>
                <div className='d-flex align-items-center' style={{ paddingTop: '50px' }}>
                  <Image src={item.image} />
                  <Caption className='px-1 px-md-4 flex-grow-1'>{item.name}</Caption>
                </div>
              </SlideWrapper>
            </TestimonialBox>
          ))}
        </div>
      </div>
    </>
  );
});

export { TestimonialSlider };
